<template>
  <div class="max-w-4xl mx-auto px-6 py-10 text-gray-800">
    <h1 class="text-3xl font-bold mb-6 text-center">Politique de Confidentialité (RGPD)</h1>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">1. Introduction</h2>
      <p>
        La présente politique de confidentialité vise à informer les utilisateurs de la plateforme BookMySalon
        sur la manière dont leurs données personnelles sont collectées, utilisées, stockées et protégées, conformément
        au Règlement Général sur la Protection des Données (RGPD).
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">2. Données collectées</h2>
      <p>Nous collectons les données personnelles suivantes :</p>
      <ul class="list-disc pl-6 mt-2">
        <li>Nom et prénom</li>
        <li>Adresse e-mail</li>
        <li>Numéro de téléphone</li>
        <li>Historique des rendez-vous</li>
        <li>Données de connexion (IP, navigateur, etc.)</li>
        <li>Données bancaires (gérées via Stripe uniquement, non stockées par BookMySalon)</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">3. Finalités de l'utilisation des données</h2>
      <p>Vos données sont utilisées pour les finalités suivantes :</p>
      <ul class="list-disc pl-6 mt-2">
        <li>Création et gestion de votre compte</li>
        <li>Réservation de rendez-vous</li>
        <li>Communication et rappels (email, SMS)</li>
        <li>Gestion des paiements et facturation</li>
        <li>Amélioration du service (statistiques, retours, etc.)</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">4. Stockage et sécurité</h2>
      <p>
        Vos données sont hébergées de manière sécurisée sur des serveurs situés en Europe. Des mesures techniques et
        organisationnelles appropriées sont mises en place pour empêcher toute perte, divulgation ou accès non autorisé.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">5. Cookies</h2>
      <p>
        Nous utilisons des cookies afin d’améliorer votre expérience utilisateur (ex : mémorisation de vos préférences,
        suivi analytique). Vous pouvez les désactiver à tout moment depuis les paramètres de votre navigateur.
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">6. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul class="list-disc pl-6 mt-2">
        <li>Droit d’accès à vos données</li>
        <li>Droit de rectification</li>
        <li>Droit d’effacement ("droit à l’oubli")</li>
        <li>Droit d’opposition ou de limitation</li>
        <li>Droit à la portabilité</li>
      </ul>
      <p class="mt-2">
        Pour exercer ces droits, contactez-nous à l’adresse :
        <a href="mailto:rgpd@bookmysalon.fr" class="text-blue-600 underline">rgpd@bookmysalon.fr</a>
      </p>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">7. Sous-traitants</h2>
      <p>Nous faisons appel à des prestataires externes qui peuvent traiter vos données :</p>
      <ul class="list-disc pl-6 mt-2">
        <li><strong>Stripe</strong> : traitement des paiements</li>
        <li><strong>Twilio</strong> : envoi de SMS (rappels de rendez-vous)</li>
        <li><strong>Mailjet / Brevo</strong> : envoi d’e-mails</li>
        <li><strong>Google Analytics</strong> : statistiques de navigation</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">8. Conservation des données</h2>
      <p>
        Vos données sont conservées pour la durée strictement nécessaire à la finalité du traitement, et au maximum 3 ans après
        la dernière activité sur votre compte, sauf obligations légales contraires.
      </p>
    </section>

    <section class="text-sm text-gray-500 mt-10 text-center">
      Dernière mise à jour : 24 juin 2025
    </section>
  </div>
</template>

<script setup>
// Aucun script requis
</script>

<style scoped>
/* Aucun style personnalisé nécessaire avec Tailwind */
</style>
